import React, { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { toast } from 'react-toastify';
import { getSuperAdminReport, getSuperAdminDetailedReport } from '../../services/SuperAdminReportService';
import Loader from '../../utility/Loader';

export default function SuperAdminReport() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    const [evaluation, setEvaluation] = useState({
        "avg_attendance": 0,
        "avg_po_score": 0,
        "no_student_more_than_90_per": 0,
        "no_student_less_than_20_per": 0,
        "most_consumed_course": "",
        "highest_assessment_course": ""
    });
    const [customerReport, setCustomerReport] = useState({
        "num_app_admin": 0, "num_active_app_admin": 0, "num_active_learners": 0, "num_active_customers": 0
    });
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
            navigate('/login');
        }else{
            setUserDetails(userDetails);
            getSuperAdminReportData(userDetails.token);
            getSuperAdminDetailedReportData(userDetails.token);
        }
    },[]);

    const getSuperAdminReportData = async (token) => {
        let resp = await getSuperAdminReport(token);
        if(resp.error === false){
            setCustomerReport(resp.data);
        }
    };

    const getSuperAdminDetailedReportData = async (token) => {
        let resp = await getSuperAdminDetailedReport(token);
        if(resp.error === false){
            setEvaluation(resp.data);
        }
    };


    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='pt-10 lg:px-12 px-6 pb-12'>
                    <h3 className='text-2xl text-secondary inter-700 lg:hidden'>Reports</h3>
                    <div className='mt-6'>
                        <div className='view-boxes-wrap flex justify-between flex-wrap mb-2'>
                            <div className='w-full md:w-[48%] xl:w-[45%] mb-6'>
                                <a onClick={() => navigate('/superadmin/superadmincustomerreport')} className='cursor-pointer evlutn-view-card flex flex-col justify-between bg-[#1D548D] min-h-72 2xl:min-h-[300px] rounded-3xl py-6 lg:py-8 xl:py-8 px-6 lg:px-8 xl:px-8'>
                                    <div className='view-hdng-wrap mb-4'>
                                        <p className='text-lg md:text-base xl:text-lg text-white inter-700'>Customer Report</p>
                                        <h3 className='view-box-ttl text-4xl md:text-3xl xl:text-4xl inter-700 text-white'>{customerReport.num_active_customers} Customer</h3>
                                    </div>
                                    <div className='evlutn-attndce-wrap'>
                                        <p className='text-lg inner-300 text-white leading-6'>{customerReport.num_active_learners}</p>
                                        <h4 className='text-2xl inner-600 text-white'>Learner</h4>
                                    </div>
                                </a>
                            </div>
                            <div className='w-full md:w-[48%] xl:w-[45%] mb-6'>
                                <a onClick={() => navigate('/superadmin/superadmincustomeradminreport')} className='cursor-pointer evlutn-view-card flex flex-col justify-between bg-[#1D548D] min-h-72 2xl:min-h-[300px] rounded-3xl py-6 lg:py-8 xl:py-8 px-6 lg:px-8 xl:px-8'>
                                    <div className='view-hdng-wrap mb-4'>
                                        <p className='text-lg text-white inter-700'>Admin Report</p>
                                        <h3 className='view-box-ttl text-4xl md:text-3xl xl:text-4xl inter-700 text-white'>{customerReport.num_app_admin} Super Admins</h3>
                                    </div>
                                    <div className='evlutn-attndce-wrap'>
                                        <p className='text-lg inner-300 text-white leading-6'>{customerReport.num_active_app_admin}</p>
                                        <h4 className='text-2xl inner-600 text-white'>Active</h4>
                                    </div>
                                </a>
                            </div>
                            {/* <div className='w-full md:w-[30%] xl:w-[28%] mb-6'>
                                <a onClick={() => navigate('/admin/learningreport')} className='cursor-pointer evlutn-view-card flex flex-col justify-between bg-[#1D548D] min-h-72 2xl:min-h-[300px] rounded-3xl py-6 lg:py-8 xl:py-8 px-6 lg:px-8 xl:px-8'>
                                    <div className='view-hdng-wrap mb-5'>
                                        <p className='text-lg text-white inter-700'>VIEW</p>
                                        <h3 className='view-box-ttl text-4xl md:text-3xl xl:text-4xl inter-700 text-white'>Topics with Highest Learning Time</h3>
                                    </div>
                                </a>
                            </div> */}
                        </div>
                        <div className='cohort-boxes-wrap flex justify-between flex-wrap'>
                            <div className='w-full md:w-[30%] xl:w-[28%] mb-6'>
                                <div className='evlutn-chrt-card flex flex-col justify-between bg-[#1D548D] h-full min-h-52 2xl:min-h-[230px] rounded-3xl py-8 lg:py-10 xl:py-14 px-6 lg:px-8 xl:px-8'>
                                    <div className='evlutn-hdng-wrap mb-5'>
                                        <h3 className='text-[1.575rem] md:text-3xl inter-700 text-white'>COHORT REPORT</h3>
                                    </div>
                                    <div className='evlutn-attndce-wrap mb-3 md:mb-5'>
                                        <h4 className='text-2xl inner-600 text-white'>{Math.ceil(evaluation.avg_attendance)}%</h4>
                                        <p className='text-lg md:text-base lg:text-lg inner-300 text-white leading-6'>Avg. Attendance</p>
                                    </div>
                                    <div className='evlutn-post-wrap mb-5 md:mb-10'>
                                        <h4 className='text-2xl inner-600 text-white'>{Math.ceil(evaluation.avg_po_score)}%</h4>
                                        <p className='text-lg md:text-base lg:text-lg inner-300 text-white leading-6'>Avg. Post Learning Assessment Score</p>
                                    </div>
                                    <div className=''>
                                        <a onClick={() => navigate('/superadmin/superadmincohortreport')} className='cursor-pointer course-btn-yellow bg-[#E76457] hover:bg-black flex items-center justify-center h-10 2xl:h-12 text-white inter-600 text-base md:text-sm lg:text-base 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'><span className='text-xl'>+ </span> View in Detail</a>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full md:w-[30%] xl:w-[28%] mb-6'>
                                <div className='evlutn-chrt-card flex flex-col justify-between bg-[#1D548D] h-full min-h-52 2xl:min-h-[230px] rounded-3xl py-8 lg:py-10 xl:py-14 px-6 lg:px-8 xl:px-8'>
                                    <div className='evlutn-hdng-wrap mb-5'>
                                        <h3 className='text-[1.575rem] md:text-3xl inter-700 text-white'>LEARNER REPORT</h3>
                                    </div>
                                    <div className='evlutn-attndce-wrap mb-3 md:mb-5'>
                                        <h4 className='text-2xl inner-600 text-white'>{evaluation.no_student_more_than_90_per} Students</h4>
                                        <p className='text-lg md:text-base lg:text-lg inner-300 text-white leading-6'>with 90% + Score</p>
                                    </div>
                                    <div className='evlutn-post-wrap mb-5 md:mb-10'>
                                        <h4 className='text-2xl inner-600 text-white'>{evaluation.no_student_less_than_20_per} Students</h4>
                                        <p className='text-lg md:text-base lg:text-lg inner-300 text-white leading-6'>with less than 20% Score</p>
                                    </div>
                                    <div className=''>
                                        <a onClick={() => navigate('/superadmin/superadminlearnerreport')} className='cursor-pointer course-btn-yellow bg-[#E76457] hover:bg-black flex items-center justify-center h-10 2xl:h-12 text-white inter-600 text-base md:text-sm lg:text-base 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'><span className='text-xl'>+ </span> View in Detail</a>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full md:w-[30%] xl:w-[28%] mb-6'>
                                <div className='evlutn-chrt-card flex flex-col justify-between bg-[#1D548D] h-full min-h-52 2xl:min-h-[230px] rounded-3xl py-8 lg:py-10 xl:py-14 px-6 lg:px-8 xl:px-8'>
                                    <div className='evlutn-hdng-wrap mb-5'>
                                        <h3 className='text-[1.575rem] md:text-3xl inter-700 text-white'>LEARNING REPORT</h3>
                                    </div>
                                    <div className='evlutn-attndce-wrap mb-3 md:mb-5'>
                                        <h4 className='text-2xl inner-600 text-white'>{evaluation.most_consumed_course}</h4>
                                        <p className='text-lg md:text-base lg:text-lg inner-300 text-white leading-6'>Top Consumed Technology</p>
                                    </div>
                                    <div className='evlutn-post-wrap mb-5 md:mb-10'>
                                        <h4 className='text-2xl inner-600 text-white'>{evaluation.highest_assessment_course}</h4>
                                        <p className='text-lg md:text-base lg:text-lg inner-300 text-white leading-6'>Highest Assessment Score</p>
                                    </div>
                                    <div className=''>
                                        <a onClick={() => navigate('/superadmin/superadminlearningreport')} className='cursor-pointer course-btn-yellow bg-[#E76457] hover:bg-black flex items-center justify-center h-10 2xl:h-12 text-white inter-600 text-base md:text-sm lg:text-base 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'><span className='text-xl'>+ </span> View in Detail</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>  
            )}
        </div>
    );
}